export default {
  manual: 'Manual',
  filters: {
    status: 'Stare',
    event_type: 'Tip eveniment',
  },
  columns: {
    event: 'Eveniment',
    status: 'Stare',
    attempts: 'Încercări',
    last_http_status: 'Ultimul status HTTP',
    created_at: 'Creat',
  },
  statuses: {
    pending: 'În așteptare',
    delivered: 'Livrat',
    failed: 'Eșuat',
  },
  buttons: {
    details: 'Detalii',
    resend: 'Retrimite',
  },
  detail: {
    title: 'Detalii livrare',
    event: 'Eveniment',
    attempts: 'Încercări',
    no_attempts: 'Nicio încercare încă.',
    no_response: 'fără răspuns',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Livrările nu au putut fi încărcate.',
    resend_error: 'Livrarea nu a putut fi retrimisă.',
    resent: 'Livrare pusă în coadă pentru retrimitere.',
  },
};
